import React, { memo } from 'react';
import Locale from '@active/react-utils/i18n/Locale';
import Alert from '@active/react-ui/Alert';

const PinpadTipAndIcons = ({ isReady }) => {
  return (
    <React.Fragment>
      <Alert theme="inline" type={isReady ? 'success' : 'danger'}>
        <Locale id={isReady ? 'checkout.lib.components.payment.pinpad.ready' : 'checkout.lib.components.payment.pinpad.notReady'}/>
      </Alert>
      <div className='pinpad-icons-container'>
        <div className="pinpad-icon">
          <span className="ic-calculator" />
          <span className={`round ${isReady ? 'ready-color' : 'unready-color'}`}>
            <span className={isReady ? 'ic-check-r' : 'ic-cross-r'}/>
          </span>
          <span className="ic-desktop-mac"/>
        </div>
      </div>
    </React.Fragment>
  );
};

export default memo(PinpadTipAndIcons);
